module.exports = __webpack_public_path__ + "static/media/whishlist-icon.854eb727.svg";